import { SocialWebStreamWidget } from 'schemas/SocialWebStreamWidgetSchema'
import { AudienceStreamWidget } from 'schemas/AudienceStreamWidgetSchema'
import { Dashboard } from 'schemas/DashboardSchema'
import { DocumentInfo } from 'schemas/DocumentInfoSchema'
import { createDocumentRetrieval } from 'utils/runSearchUtil'
import { toFilter } from 'utils/widgetUtil'

const createDocumentSearch = (
  widgetSetting: SocialWebStreamWidget | AudienceStreamWidget,
  dashboardData: Dashboard,
  fingerprints: DocumentInfo[],
  fingerprintIndex: number
) => {
  const { sort, selectedTopic, precision, maxSoundbites } = widgetSetting
  const { id: dashboardId, name } = dashboardData
  const filter = toFilter(widgetSetting)

  const documentIds: string[] = fingerprints!
    .slice(fingerprintIndex, fingerprintIndex + maxSoundbites!)
    .map((fingerprint) => fingerprint.documentFingerprint!)!

  return createDocumentRetrieval(
    dashboardId!,
    name!,
    [selectedTopic.topicId!],
    documentIds,
    filter,
    precision!,
    sort!
  )
}

export default createDocumentSearch
